module.exports = __webpack_public_path__ + "intercom-video-thumbnail-53f13b9e8ebf35866a057033bda95152.webp";